import dateandtime from 'date-and-time';
import helpers from 'helpers/index';
import Pagination from 'components/pagination';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  TypedTransactionAnalytics,
  TypedTransactions,
  useDownloadTransactions,
  useGetTransactions,
  useMutateDeleteTransactions,
  useMutateReloadTransactions,
  ENUM_TRANSACTION_PAYMENT_METHOD,
} from 'queries/transactions.query';
import { Helmet } from 'react-helmet-async';
import { BlockStack, Box, Button, Card, Checkbox, DataTable, Icon, InlineStack, Link, Page, SkeletonBodyText, Text, Tooltip } from '@shopify/polaris';
import { ___ } from 'languages/index';
import { BillFilledIcon, CashDollarFilledIcon, DeleteIcon, RefreshIcon, UploadIcon, PageDownIcon } from '@shopify/polaris-icons';
import TransactionFilter from './filter';
import TransactionModal from './transaction.modal';
import TransactionsUploadModal from './transations.upload.modal';
import { useDeleteConfirm } from 'context/DeleteConfirmContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import DebitClearModal from './debit_clear.modal';

export default function Transactions() {
  const rootSearchPath = window.location.search;
  /**
   * If user apply filter, it will add to URL, then parse URL back to initial state
   */
  const { start, end } = helpers.getDayRange(new Date());
  let StringQuery: any = helpers.ExtractUrl(rootSearchPath) || false;
  const initialQuery = {
    query: '',
    page: 1,
    limit: 200,
    casher: '',
    createdAt: `lte:${end},gte:${start}`,
    sort: 'createdAt:desc',
  };

  const [mainQuery, setMainQuery] = useState<any>({
    ...initialQuery,
    ...StringQuery,
  });

  // const [defaultDate, setDefaultDate] = useState<{ startDate: string; endDate: string }>({
  //   startDate: dateandtime.format(new Date(), 'YYYY-MM-DD 00:00:00'),
  //   endDate: dateandtime.format(new Date(), 'YYYY-MM-DD 23:59:59'),
  // });

  // useEffect(() => {
  //   let fromTimeStamp = new Date(defaultDate.startDate).getTime();
  //   let toTimeStamp = new Date(defaultDate.endDate).getTime();
  //   setMainQuery((prevMainQuery) => ({ ...prevMainQuery, payment_method: '', createdAt: `lte:${toTimeStamp},gte:${fromTimeStamp}` }));
  // }, [defaultDate]);

  // const dateChangeCallback = useCallback((_e) => {
  //   let { since, until } = _e.period;
  //   let FNS = {
  //     startDate: '',
  //     endDate: '',
  //   };
  //   if (since) {
  //     FNS.startDate = new Date(dateandtime.format(since, 'YYYY-MM-DD 00:00:00')).toISOString();
  //   }
  //   if (until) {
  //     FNS.endDate = new Date(dateandtime.format(until, 'YYYY-MM-DD 23:59:59')).toISOString();
  //   }
  //   setDefaultDate(FNS);
  // }, []);

  const { refetch: getEntities, data, isFetching: loading } = useGetTransactions(mainQuery);

  const [entities, setEntities] = useState<TypedTransactions[]>([]);
  const [analyticsData, setAnalyticsData] = useState<TypedTransactionAnalytics>(null);
  const [totalItems, setTotalItems] = useState(0);
  useEffect(() => {
    if (data) {
      let { transactions, analytics, totalItems } = data;
      setEntities(transactions);
      setAnalyticsData(analytics);
      setTotalItems(totalItems);
    }
  }, [data]);
  /**
   * Change page number
   * Must be mainQuery or it will reset mainQuery. BUG!
   */
  const onChangePagination = useCallback((numPage: number, limit: number) => {
    setMainQuery((prevMainQuery) => ({ ...prevMainQuery, page: numPage, limit: limit }));
  }, []);

  const reduceRequest = useCallback((mainQuery) => {
    getEntities();
    return mainQuery;
  }, []);

  const reduceRequestMemo = useMemo(() => {
    return helpers.debounce((_value) => {
      reduceRequest?.call(this, _value);
    }, 500);
  }, []);

  /**
   * I do not know ...
   * Bug: In React, do NOT remove this code
   */
  const filterCallback = useCallback((_value: any) => {
    if (_value === false) {
      return setMainQuery(initialQuery);
    } else {
      setMainQuery((oldValue) => {
        return { ...oldValue, ..._value };
      });
    }
  }, []);

  useEffect(() => {
    let buildURLSearch = helpers.buildEndUrl(mainQuery);
    if (window.location.search !== buildURLSearch) {
      window.history.replaceState(null, 'Transactions', '/transactions' + buildURLSearch);
    }
    reduceRequestMemo(mainQuery);
  }, [mainQuery]);

  /******** KHỐI PHÁT HIỆN MOBILE */
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 800px)');
    const handleChange = (event: MediaQueryListEvent | MediaQueryList) => {
      const matches = 'matches' in event ? event.matches : mediaQuery.matches;
      setIsMobile(matches);
    };

    handleChange(mediaQuery);
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange as (event: MediaQueryListEvent) => void);
    } else {
      mediaQuery.addListener(handleChange as (event: MediaQueryListEvent) => void);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handleChange as (event: MediaQueryListEvent) => void);
      } else {
        mediaQuery.removeListener(handleChange as (event: MediaQueryListEvent) => void);
      }
    };
  }, []);

  /** Gán một giao dịch nào đó vào vé nào đó */
  const currentTransactionForAssign = useRef(null);
  const [showModalEditTransaction, setShowModalEditTransaction] = useState(false);

  const { mutateAsync: downloadExcelThisFilter, isPending: downloadGenerating } = useDownloadTransactions();
  const generateDownloadLink = useCallback(async () => {
    try {
      const blob = await downloadExcelThisFilter(mainQuery);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');

      a.href = url;
      a.download = 'transactions.xlsx';

      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);
    } catch (e) {}
  }, [mainQuery]);

  /** reload  */

  const { mutateAsync: reloadATransactions, isPending: reloading } = useMutateReloadTransactions();
  const { mutateAsync: deleteATransactions, isPending: deleting } = useMutateDeleteTransactions();
  const reloadButtonClickID = useRef(null);
  const reloadThisCallback = useCallback(async (transactions_id: any) => {
    //
    try {
      await reloadATransactions(transactions_id);
    } catch (e) {}
    reloadButtonClickID.current = null;
  }, []);

  /** xóa một transactions */
  const { showDeleteConfirm } = useDeleteConfirm();
  const deleteButtonClickID = useRef(null);
  const deleteThisCallback = useCallback(async (transactions_id: any) => {
    //
    const agree = await showDeleteConfirm(
      'Bạn chắc chắn muốn xóa giao dịch này?',
      'Một giao dịch chưa ghép được vào bất kỳ đơn nào có thể xóa tại đây, và không thể khôi phục.'
    );
    if (agree) {
      try {
        await deleteATransactions(transactions_id);
      } catch (e) {}
    }
    deleteButtonClickID.current = null;
  }, []);

  const [show, setShow] = useState(false);
  const [showDebitClearModal, setShowDebitClearModal] = useState(false);
  const [selectedDebtTransactionIDs, setSelectedDebtTransactionIDs] = useState<any[]>([]);

  const isDebtTransaction = useCallback((transaction: TypedTransactions) => {
    if (!transaction?.payment_method) return false;

    return [
      ENUM_TRANSACTION_PAYMENT_METHOD.DEBT_CUSTOMER,
      ENUM_TRANSACTION_PAYMENT_METHOD.DEBT_AGENT,
      ENUM_TRANSACTION_PAYMENT_METHOD.THIRD_PARTY,
    ].includes(transaction.payment_method);
  }, []);

  const visibleDebtTransactionIDs = useMemo(() => {
    return (
      entities
        ?.filter(isDebtTransaction)
        .map((transaction) => transaction.id)
        .filter(Boolean) || []
    );
  }, [entities, isDebtTransaction]);

  const allVisibleDebtSelected =
    visibleDebtTransactionIDs.length > 0 && visibleDebtTransactionIDs.every((id) => selectedDebtTransactionIDs.includes(id));
  const someVisibleDebtSelected = visibleDebtTransactionIDs.some((id) => selectedDebtTransactionIDs.includes(id));

  const toggleSelectAllDebtTransactions = useCallback(() => {
    setSelectedDebtTransactionIDs((currentSelectedIDs) => {
      if (visibleDebtTransactionIDs.length > 0 && visibleDebtTransactionIDs.every((id) => currentSelectedIDs.includes(id))) {
        return currentSelectedIDs.filter((id) => !visibleDebtTransactionIDs.includes(id));
      }

      return Array.from(new Set([...currentSelectedIDs, ...visibleDebtTransactionIDs]));
    });
  }, [visibleDebtTransactionIDs]);

  const toggleSelectDebtTransaction = useCallback(
    (transaction: TypedTransactions) => {
      if (!isDebtTransaction(transaction) || !transaction?.id) return;

      setSelectedDebtTransactionIDs((currentSelectedIDs) => {
        if (currentSelectedIDs.includes(transaction.id)) {
          return currentSelectedIDs.filter((id) => id !== transaction.id);
        }

        return [...currentSelectedIDs, transaction.id];
      });
    },
    [isDebtTransaction]
  );

  const closeDebitClearModal = useCallback(() => {
    setShowDebitClearModal(false);
    setSelectedDebtTransactionIDs([]);
  }, []);

  return (
    <>
      <Helmet>
        <title>Danh sách giao dịch</title>
      </Helmet>
      <Page
        title="Danh sách giao dịch"
        fullWidth
        secondaryActions={[
          {
            content: 'Tải lên',
            onAction: () => setShow(true),
            icon: UploadIcon,
          },
        ]}
        primaryAction={{
          loading: downloadGenerating,
          icon: PageDownIcon,
          content: 'Tải xuống bản này',
          onAction: () => {
            generateDownloadLink();
          },
        }}
      >
        <BlockStack gap="400">
          <InlineStack gap={isMobile ? '200' : '400'} wrap>
            <Box minWidth={isMobile ? '100%' : '220px'} width={isMobile ? '100%' : undefined}>
              <Card padding="300">
                <BlockStack gap="100">
                  <InlineStack gap="200" blockAlign="center" align="start" wrap={false}>
                    <Box as="span">
                      <Icon source={CashDollarFilledIcon} tone="subdued" />
                    </Box>
                    <Text as="span" tone="subdued">
                      Tiền mặt
                    </Text>
                  </InlineStack>
                  {loading ? (
                    <Text variant="headingMd" fontWeight="regular" as="p" tone="subdued">
                      <SkeletonBodyText lines={2} />
                    </Text>
                  ) : (
                    <>
                      <Text variant="headingLg" as="p">
                        {helpers.formatNumberWithCommas(analyticsData?.sum.CASH)} VND
                      </Text>
                      <Text variant="headingMd" fontWeight="regular" as="p" tone="subdued">
                        Trong tổng {helpers.formatNumberWithCommas(analyticsData?.count.CASH)} giao dịch
                      </Text>
                    </>
                  )}
                </BlockStack>
              </Card>
            </Box>

            <Box minWidth={isMobile ? '100%' : '220px'} width={isMobile ? '100%' : undefined}>
              <Card padding="300">
                <BlockStack gap="100">
                  <InlineStack gap="200" blockAlign="center" align="start" wrap={false}>
                    <Box as="span">
                      <Icon source={BillFilledIcon} tone="subdued" />
                    </Box>
                    <Text as="span" tone="subdued">
                      Chuyển khoản
                    </Text>
                  </InlineStack>
                  <Text variant="headingLg" as="p">
                    {helpers.formatNumberWithCommas(analyticsData?.sum.BANK)} VND
                  </Text>
                  <Text variant="headingMd" fontWeight="regular" as="p" tone="subdued">
                    Trong tổng {helpers.formatNumberWithCommas(analyticsData?.count.BANK)} giao dịch
                  </Text>
                </BlockStack>
              </Card>
            </Box>

            <Box minWidth={isMobile ? '100%' : '220px'} width={isMobile ? '100%' : undefined}>
              <Card padding="300">
                <BlockStack gap="100">
                  <InlineStack gap="200" blockAlign="center" align="start" wrap={false}>
                    <Box as="span">
                      <Icon source={BillFilledIcon} tone="subdued" />
                    </Box>
                    <Text as="span" tone="subdued">
                      Chưa vào hóa đơn
                    </Text>
                  </InlineStack>
                  <Text variant="headingLg" as="p">
                    {helpers.formatNumberWithCommas(analyticsData?.sum_unsigned.amount)} VND
                  </Text>
                  <Text variant="headingMd" fontWeight="regular" as="p" tone="subdued">
                    Trong tổng {helpers.formatNumberWithCommas(analyticsData?.sum_unsigned.count)} giao dịch
                  </Text>
                </BlockStack>
              </Card>
            </Box>

            <Box minWidth={isMobile ? '100%' : '220px'} width={isMobile ? '100%' : undefined}>
              <Card padding="300" background="bg-fill-caution">
                <BlockStack gap="100">
                  <InlineStack gap="200" blockAlign="center" align="start" wrap={false}>
                    <Box as="span">
                      <Icon source={BillFilledIcon} tone="subdued" />
                    </Box>
                    <Text as="span" tone="subdued">
                      Công nợ khách
                    </Text>
                  </InlineStack>
                  <Text variant="headingLg" as="p">
                    {helpers.formatNumberWithCommas(analyticsData?.sum.DEBT_CUSTOMER)} VND
                  </Text>
                  <Text variant="headingMd" fontWeight="regular" as="p" tone="subdued">
                    Trong tổng {helpers.formatNumberWithCommas(analyticsData?.count.DEBT_CUSTOMER)} giao dịch
                  </Text>
                </BlockStack>
              </Card>
            </Box>
            <Box minWidth={isMobile ? '100%' : '220px'} width={isMobile ? '100%' : undefined}>
              <Card padding="300" background="bg-fill-caution">
                <BlockStack gap="100">
                  <InlineStack gap="200" blockAlign="center" align="start" wrap={false}>
                    <Box as="span">
                      <Icon source={BillFilledIcon} tone="subdued" />
                    </Box>
                    <Text as="span" tone="subdued">
                      Công nợ đại lý
                    </Text>
                  </InlineStack>
                  <Text variant="headingLg" as="p">
                    {helpers.formatNumberWithCommas(analyticsData?.sum.DEBT_AGENT)} VND
                  </Text>
                  <Text variant="headingMd" fontWeight="regular" as="p" tone="subdued">
                    Trong tổng {helpers.formatNumberWithCommas(analyticsData?.count.DEBT_AGENT)} giao dịch
                  </Text>
                </BlockStack>
              </Card>
            </Box>
            <Box minWidth={isMobile ? '100%' : '220px'} width={isMobile ? '100%' : undefined}>
              <Card padding="300" background="bg-fill-caution">
                <BlockStack gap="100">
                  <InlineStack gap="200" blockAlign="center" align="start" wrap={false}>
                    <Box as="span">
                      <Icon source={BillFilledIcon} tone="subdued" />
                    </Box>
                    <Text as="span" tone="subdued">
                      Công nợ bên thứ ba
                    </Text>
                  </InlineStack>
                  <Text variant="headingLg" as="p">
                    {helpers.formatNumberWithCommas(analyticsData?.sum.THIRD_PARTY)} VND
                  </Text>
                  <Text variant="headingMd" fontWeight="regular" as="p" tone="subdued">
                    Trong tổng {helpers.formatNumberWithCommas(analyticsData?.count.THIRD_PARTY)} giao dịch
                  </Text>
                </BlockStack>
              </Card>
            </Box>
          </InlineStack>
        </BlockStack>
        <br />
        <Card padding="0">
          <TransactionFilter onCallback={filterCallback} loading={loading} />
          {selectedDebtTransactionIDs.length > 0 ? (
            <Box padding="300">
              <InlineStack align="space-between" blockAlign="center" gap="300">
                <Text as="p" tone="subdued">
                  Đã chọn {selectedDebtTransactionIDs.length} giao dịch công nợ
                </Text>
                <Button variant="primary" onClick={() => setShowDebitClearModal(true)}>
                  Gạt công nợ
                </Button>
              </InlineStack>
            </Box>
          ) : null}
          <DataTable
            verticalAlign="middle"
            hideScrollIndicator={true}
            stickyHeader
            increasedTableDensity
            columnContentTypes={[
              'text',
              'text',
              'text',
              'text',
              'text',
              'text',
              'text',
              'text',
              'text',
              'text',
              'text',
              'text',
              'text',
              'text',
              'numeric',
            ]}
            headings={[
              <Checkbox
                label="Chọn tất cả giao dịch công nợ"
                labelHidden
                checked={allVisibleDebtSelected ? true : someVisibleDebtSelected ? 'indeterminate' : false}
                disabled={visibleDebtTransactionIDs.length === 0}
                onChange={toggleSelectAllDebtTransactions}
              />,
              'ID',
              '-',
              'Số tiền',
              'Phương thức',
              'Nội dung',
              'Đơn hàng',
              'Ngày đi',
              'Xe',
              'Tài xế',
              'Số hóa đơn',
              'Ngày xuất HD',
              'Người thu tiền',
              'Ngày thanh toán',
              'Ngày gạt nợ',
              'Người gạt nợ',
              'Ghi chú gạt nợ',
              'Công cụ',
            ]}
            rows={
              entities?.map((transaction) => {
                const {
                  id,
                  order_id,
                  invoice_id,
                  order_data,
                  amount,
                  payment_method,
                  description,
                  note,
                  lastError,
                  casher_data,
                  createdAt,
                  vehicle_data,
                  driver_data,
                  invoice_data,
                  debt_clear_note,
                  debt_cleared_at,
                  debt_cleared_by,
                  debt_clearer,
                } = transaction;
                let trip_hour = dateandtime.format(new Date(Number(order_data?.departure_date)), 'HH:mm');
                let trip_date_reformat = dateandtime.format(new Date(Number(order_data?.departure_date)), 'YYYY-MM-DD');
                let journey_id = order_data?.journey_id;
                let ticket = order_data?.ticket;
                let trip_manifest_ticket = null;
                if (ticket && typeof ticket[0] !== 'undefined') {
                  trip_manifest_ticket = ticket[0]?.trip_manifest_ticket;
                }

                let order_link = null;
                if (order_data) {
                  order_link = (
                    <Link
                      url={`/ticket_managers?d=${trip_date_reformat}&journey_id=${journey_id}&htext=${trip_hour}&h=${trip_manifest_ticket?.trip_manifest?.time_id}#${order_id}`}
                    >{`${order_data?.order_code}`}</Link>
                  );
                }

                let invoice_link = null;
                if (invoice_data) {
                  invoice_link = (
                    <Text variant="bodyMd" fontWeight="bold" as="span">
                      <Link url={process.env.REACT_APP_BACKEND_URL + `/invoices/view_pdf/${invoice_data.maTraCuu}` || '#'} target="_blank">
                        {invoice_data.shDon}
                      </Link>
                    </Text>
                  );
                }

                const statusBadge = invoice_data ? null : <span style={{ color: 'red' }}>&bull;</span>;

                const canSelectDebtTransaction = isDebtTransaction(transaction);

                return [
                  <Checkbox
                    label={`Chọn giao dịch công nợ ${id}`}
                    labelHidden
                    checked={selectedDebtTransactionIDs.includes(id)}
                    disabled={!canSelectDebtTransaction}
                    onChange={() => toggleSelectDebtTransaction(transaction)}
                  />,
                  id,
                  statusBadge,
                  helpers.formatNumberWithCommas(amount),
                  payment_method,
                  <BlockStack>
                    <Text as="p">{description}</Text>
                    {note && (
                      <Text as="p" tone="critical">
                        {note}
                      </Text>
                    )}
                    {lastError ? (
                      <Text as="p" tone="critical">
                        <FontAwesomeIcon icon={faWarning} />
                        {lastError}
                      </Text>
                    ) : null}
                  </BlockStack>,
                  order_link || (
                    <Tooltip content={'Gắn nó vào một đơn hàng'}>
                      <Link
                        onClick={() => {
                          currentTransactionForAssign.current = id;
                          setShowModalEditTransaction(true);
                        }}
                      >
                        --
                      </Link>
                    </Tooltip>
                  ),
                  order_data?.departure_date ? dateandtime.format(new Date(Number(order_data?.departure_date)), 'HH:mm DD/MM/YYYY') : '--',
                  vehicle_data?.license_plate || '-',
                  driver_data?.display_name || '-',
                  invoice_link || '-',
                  invoice_data ? dateandtime.format(new Date(Number(invoice_data?.signedAt)), 'HH:mm DD/MM/YYYY') : '-',
                  casher_data?.display_name || '-',
                  <Text as="p" tone="subdued">
                    {dateandtime.format(new Date(Number(createdAt)), 'HH:mm DD-MM-YYYY')}
                  </Text>,

                  debt_cleared_at ? dateandtime.format(new Date(Number(debt_cleared_at)), 'HH:mm DD/MM/YYYY') : '--',
                  debt_clearer?.display_name || '--',
                  debt_clear_note || '--',
                  !invoice_id ? (
                    <InlineStack align="start" blockAlign="center" gap="400" wrap={false}>
                      <Button
                        variant="plain"
                        onClick={() => {
                          reloadButtonClickID.current = id;
                          reloadThisCallback(id);
                        }}
                        icon={RefreshIcon}
                        loading={reloading && reloadButtonClickID.current === id}
                      ></Button>
                      <Button
                        variant="plain"
                        onClick={() => {
                          deleteButtonClickID.current = id;
                          deleteThisCallback(id);
                        }}
                        icon={DeleteIcon}
                        loading={deleting && deleteButtonClickID.current === id}
                      ></Button>
                    </InlineStack>
                  ) : null,
                ];
              }) || []
            }
            footerContent={___('Show page {display_page_number} of {total_record_number} results', {
              display_page_number: <Text as="strong">{mainQuery?.page || 1}</Text>,
              total_record_number: <Text as="strong">{totalItems}</Text>,
            })}
          />
        </Card>

        <br />
        {totalItems > 0 ? (
          <Pagination
            TotalRecord={totalItems}
            onChange={onChangePagination}
            pageSize={Number(mainQuery?.limit)}
            activeCurrentPage={Number(mainQuery?.page)}
          />
        ) : null}
      </Page>
      <br />
      <br />
      <br />
      <br />

      <TransactionModal
        currentTransaction={currentTransactionForAssign.current}
        show={showModalEditTransaction}
        onClose={() => {
          currentTransactionForAssign.current = null;
          setShowModalEditTransaction(false);
        }}
      />

      <TransactionsUploadModal
        onClose={() => {
          setShow(false);
        }}
        show={show}
      />

      <DebitClearModal show={showDebitClearModal} transactionsID={selectedDebtTransactionIDs} onClose={closeDebitClearModal} />
    </>
  );
}

